import React from 'react';
import SubmissionList from '../components/Submission/SubmissionList';

export default function SubmissionListPage() {
  return (
      <SubmissionList />
  );
}
